/* eslint-disable react/prop-types */
/* eslint-disable prettier/prettier */
import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { Stack, Stepper, Step, StepLabel, StepConnector, Box, Grow } from "@mui/material";
import Check from "@mui/icons-material/Check";
import { stepConnectorClasses } from "@mui/material/StepConnector";

import backgroundImage from "assets/images/fondoesf.jpeg";
import CardProcesos from "./cardProcesos";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 15,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: "linear-gradient(136deg, #5873B8 0%, #1D1D1B 100%)",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: "linear-gradient(136deg, #5873B8 0%, #1D1D1B 100%)",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
}));

// === Íconos personalizados ===

const QontoStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  color: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#eaeaf0",
  display: "flex",
  height: 22,
  alignItems: "center",
  ...(ownerState.active && { color: "#784af4" }),
  "& .QontoStepIcon-completedIcon": {
    color: "#784af4",
    zIndex: 1,
    fontSize: 18,
  },
  "& .QontoStepIcon-circle": {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;
  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
};

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 30,
  height: 30,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundImage: "linear-gradient(136deg, #605CA9 0%, #5873B8 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundImage: "linear-gradient(136deg, #605CA9 0%, #5873B8 100%)",
  }),
}));

function ColorlibStepIcon(props) {
  const { active, completed, className, icon } = props;
  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {icon}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

export default function StepeperProcesos({ steps }) {
  const [activeStep, setActiveStep] = React.useState(0);
  const [growIn, setGrowIn] = React.useState(true);
  const [hoverActivo, setHoverActivo] = React.useState(false);

  // Animación Grow en cada cambio de paso
  React.useEffect(() => {
    if (hoverActivo) return;

    const intervalo = setInterval(() => {
      setActiveStep((prev) => (prev + 1) % steps.length);
    }, 2000);

    return () => clearInterval(intervalo);
  }, [hoverActivo, steps.length]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Stack sx={{ width: "100%", alignItems: "center", mt: 5 }} spacing={4}>
        {/* Colorlib Stepper */}
        <Stepper
          alternativeLabel
          activeStep={activeStep}
          connector={<ColorlibConnector />}
          sx={{
            backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.info.main, 0),
                rgba(gradients.info.state, 0.6)
              )}, url(${backgroundImage})`,
            backgroundSize: "cover",
            backgroundPosition: "50%",
            overflow: "hidden",
            width: "80%",
          }}
        >
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel StepIconComponent={ColorlibStepIcon}></StepLabel>
            </Step>
          ))}
        </Stepper>

        {/* Contenido animado con Grow */}
        <Grow in={growIn} timeout={500} key={activeStep}>
          <Box display="flex" flexWrap="wrap" gap={2} justifyContent="center">
            <CardProcesos
              numero={steps[activeStep].numero}
              titulo={steps[activeStep].titulo}
              pasos={steps[activeStep].pasos}
              roles={steps[activeStep].roles}
              onHoverEnter={() => setHoverActivo(true)}
              onHoverLeave={() => setHoverActivo(false)}
            />
          </Box>
        </Grow>
      </Stack>
      <Footer />
    </DashboardLayout>
  );
}
